<template>
    <div>
        <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
        <v-main>
            <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
                <v-row>
                    <v-col cols="6" class="text-left">
                        <!-- <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs> -->
                    </v-col>
                    <v-col cols="6" class="v-margit_button text-right">
                        <v-btn color="primary" depressed @click="dialogAdd = true">
                        <v-icon left>mdi-text-box-plus</v-icon>
                        เพิ่ม POS
                        </v-btn>
                    </v-col>
                </v-row>
                <!-- ADD -->
                <v-dialog v-model="dialogAdd" persistent max-width="35%">
                    <v-card>
                    <v-card-text>
                        <v-container>
                        <v-row>
                            <v-col cols="8" class="text-left pt-10">
                            <h3><strong>เพิ่ม POS</strong></h3>
                            </v-col>
                            <v-col cols="4" class="pt-10">
                            <div style="text-align: end;">
                                <v-btn
                                class="mx-2"
                                fab
                                small
                                dark
                                color="white"
                                :style="styleCloseBt"
                                @click="dialogAdd = false,clearData()"
                                >
                                X
                                </v-btn>
                            </div>
                            </v-col>
                        </v-row>
                        <v-form
                            ref="form_add"
                            v-model="valid_add"
                            lazy-validation
                        >
                            <v-row>
                                <v-col cols="12" class="pb-0">
                                  <v-img
                                    aspect-ratio="6"
                                    contain
                                    :src="filesImageAddPreview"
                                  ></v-img>
                                  <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                                  <br />
                                  <v-file-input
                                    required
                                    counter
                                    show-size
                                    :rules="[rules.resizeImag]"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera"
                                    label="รูปภาพ"
                                    v-model="filesImageAdd"
                                    @change="selectImg(filesImageAdd)"
                                  ></v-file-input>
                                </v-col>
                                <v-col cols="12" class="pb-0">
                                    <v-autocomplete
                                        class="pa-0"
                                        v-model="formAdd.masBranchID"
                                        :items="branch"
                                        label="สาขา"
                                        outlined
                                        required
                                        attach
                                        :menu-props="{ bottom: true, offsetY: true }"
                                        :rules="[rules.required]"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col>
                                    <v-btn
                                        elevation="2"
                                        block
                                        large
                                        color="#173053"
                                        dark
                                        :disabled="!valid_add"
                                        @click="addData()"
                                    >
                                        <v-icon left>mdi-checkbox-marked-circle</v-icon>
                                        บันทึก
                                    </v-btn>
                                </v-col>
                        </v-row>
                        </v-form>
                        </v-container>
                    </v-card-text>
                    </v-card>
                </v-dialog>
                <!-- end add -->
                 <v-dialog v-model="internalDialog" max-width="90vw">
                    <v-card class="pa-0">
                        <v-container>
                            <v-row>
                                <v-col cols="8" class="text-left pt-10">
                                <h3><strong>แสดงรูปตัวอย่าง</strong></h3>
                                </v-col>
                                <v-col cols="4" class="pt-10">
                                <div style="text-align: end;">
                                    <v-btn
                                    class="mx-2"
                                    fab
                                    small
                                    dark
                                    color="white"
                                    :style="styleCloseBt"
                                    @click="internalDialog = false"
                                    >
                                    X
                                    </v-btn>
                                </div>
                                </v-col>
                            </v-row>
                                <v-card-text class="pa-0">
                                <v-img
                                    :src="img"
                                    contain
                                    max-height="85vh"
                                    width="100%"
                                    class="rounded"
                                />
                                </v-card-text>
                        </v-container>
                    </v-card>
                </v-dialog>
                 <!-- Edit -->
                <v-dialog v-model="dialogUpdate" persistent max-width="35%">
                    <v-card>
                    <v-card-text>
                        <v-container>
                        <v-row>
                            <v-col cols="8" class="text-left pt-10">
                            <h3><strong>อัพเดท POS</strong></h3>
                            </v-col>
                            <v-col cols="4" class="pt-10">
                            <div style="text-align: end;">
                                <v-btn
                                class="mx-2"
                                fab
                                small
                                dark
                                color="white"
                                :style="styleCloseBt"
                                @click="dialogUpdate = false,clearData()"
                                >
                                X
                                </v-btn>
                            </div>
                            </v-col>
                        </v-row>
                        <v-form
                            ref="form_update"
                            v-model="valid_update"
                            lazy-validation
                        >
                            <v-row>
                                <v-col cols="12" class="pb-0">
                                  <v-img
                                    aspect-ratio="6"
                                    contain
                                    :src="filesImageUpdatePreview"
                                  ></v-img>
                                  <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                                  <br />
                                  <v-file-input
                                    required
                                    counter
                                    show-size
                                    :rules="[rules.resizeImag]"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera"
                                    label="รูปภาพ"
                                    v-model="filesImageUpdate"
                                    @change="selectImgUpdate(filesImageUpdate)"
                                  ></v-file-input>
                                </v-col>
                                <v-col cols="12" class="pb-0">
                                    <v-autocomplete
                                        class="pa-0"
                                        v-model="formUpdate.masBranchID"
                                        :items="branch"
                                        label="สาขา"
                                        outlined
                                        required
                                        attach
                                        :menu-props="{ bottom: true, offsetY: true }"
                                        :rules="[rules.required]"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col>
                                    <v-btn
                                        elevation="2"
                                        block
                                        large
                                        color="#173053"
                                        dark
                                        :disabled="!valid_update"
                                        @click="updateData()"
                                    >
                                        <v-icon left>mdi-checkbox-marked-circle</v-icon>
                                        แก้ไข
                                    </v-btn>
                                </v-col>
                        </v-row>
                        </v-form>
                        </v-container>
                    </v-card-text>
                    </v-card>
                </v-dialog>
                <!-- end edit -->
                <v-row>
                    <v-col cols="12">
                        <v-card elevation="7" v-if="dataReady">
                        <v-card-title>
                            <v-text-field
                            v-model="searchAll2"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                            ></v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table
                            :headers="columns"
                            :items="dataItem"
                            :search="searchAll2"
                            :items-per-page="10"
                            >
                            <template v-slot:[`item.CREATE_DATE`]="{ item }">
                                {{ format_date(item.CREATE_DATE) }}
                            </template>
                            <template v-slot:[`item.LAST_DATE`]="{ item }">
                                {{ format_date(item.LAST_DATE) }}
                            </template>
                            <template v-slot:[`item.urlImage`]="{ item }">
                                <v-avatar
                                    size="36px"
                                >
                                    <img
                                        v-if="item.urlImage"
                                        alt="Avatar"
                                        :src="item.urlImage"
                                        @click="openDialogPreView(item.urlImage)"
                                    />
                                </v-avatar>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <v-btn
                                color="question"
                                fab
                                dark
                                small
                                @click="setEditData(item)"
                                >
                                <v-icon dark> mdi-tools </v-icon>
                                </v-btn>
                                <v-btn
                                color="red"
                                dark
                                fab
                                small
                                >
                                <v-icon> mdi-delete </v-icon>
                                </v-btn>
                            </template>
                            </v-data-table>
                        </v-card-text>
                        </v-card>
                        <div v-if="!dataReady" class="text-center">
                        <waitingAlert></waitingAlert>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-main>
    </div>
</template>
<script>
import waitingAlert from '../waitingAlert.vue'
import axios from 'axios' // api
export default {
  components: {
    waitingAlert
  },
  data () {
    return {
      internalDialog: false,
      img: null,
      valid_add: true,
      valid_update: true,
      dialogAdd: false,
      dialogUpdate: false,
      dataReady: true,
      searchAll2: '',
      path: '/pos_management/',
      columns: [
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'รูป', value: 'urlImage', align: 'center' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        requiredArray: value => value.length > 0 || 'กรุณาเลือกประเภทบริการ',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      branch: [],
      filesImageAdd: null,
      filesImageAddPreview: null,
      filesImageUpdate: null,
      filesImageUpdatePreview: null,
      formAdd: {
        masBranchID: '',
        urlImage: '',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: this.$session.getAll().data.userName,
        LAST_USER: this.$session.getAll().data.userName
      },
      formUpdateId: '',
      formUpdate: {
        masBranchID: '',
        urlImage: '',
        LAST_USER: this.$session.getAll().data.userName
      }
    }
  },
  async mounted () {
    this.getDataBranch()
    await this.getDataGlobal(this.$DNS_IP, this.path, this.$session.getAll().data.shopId)
  },
  methods: {
    async openDialogPreView (gallery) {
      this.img = gallery || null
      this.internalDialog = true
    },
    async getDataBranch () {
      this.branch = []
      await axios
        .get(this.$DNS_IP + '/master_branch/get?shopId=' + this.$session.getAll().data.shopId)
        .then(response => {
          let rs = response.data
          console.log('rs', rs)
          if (rs.length > 0) {
            let All = {}
            All.text = 'ทั้งหมด'
            All.value = 'All'
            this.branch.push(All)
            for (var i = 0; i < rs.length; i++) {
              let d = rs[i]
              let s = {}
              s.text = d.masBranchName
              s.value = d.masBranchID.toString()
              this.branch.push(s)
            }
          }
        }).catch(function (error) {
          console.log('Error getDataBranch: ' + error)
        })
      console.log('branch', this.branch)
    },
    selectImg (files) {
      if (files) {
        this.filesImageAddPreview = URL.createObjectURL(this.filesImageAdd)
        this.formAdd.urlImage = ''
      } else {
        this.filesImageAddPreview = ''
      }
      // console.log(event)
    },
    selectImgUpdate (files) {
      if (files) {
        this.filesImageUpdatePreview = URL.createObjectURL(this.filesImageUpdate)
        this.formUpdate.urlImage = ''
      } else {
        this.filesImageUpdatePreview = ''
      }
      // console.log(event)
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    setEditData (item) {
      this.formUpdateId = item.id
      this.formUpdate.masBranchID = item.masBranchID
      this.formUpdate.urlImage = item.urlImage
      this.filesImageUpdatePreview = item.urlImage
      this.dialogUpdate = true
    },
    async updateData () {
      this.validate('UPDATE')
      setTimeout(() => this.updateDataSubmit(), 500)
    },
    async updateDataSubmit () {
      console.log('this.formUpdate.urlImage', this.formUpdate.urlImage)

      if (this.validUpdate !== false) {
        this.dataReady = false
        this.$swal({
          title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async result => {
            if (this.filesImageUpdate && this.formUpdate.urlImage === '') {
              const _this = this
              let params = new FormData()
              params.append('file', this.filesImageUpdate)
              await axios
                .post(this.$DNS_IP + `/file/upload/settingPos`, params)
                .then(function (response) {
                  _this.formUpdate.urlImage = response.data
                  console.log('url Pic', response.data)
                })
            }
            console.log('forUpdate', this.formUpdate)
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.$DNS_IP + this.path + "edit/" + this.formUpdateId,
                this.formUpdate
              )
              .then(async response => {
                console.log('updateDataGlobal DNS_IP + PATH + "update"', response)
                if (response.data.status) {
                  // Close Dialog
                  this.dialogUpdate = false

                  // Load Data
                  await this.getDataGlobal(
                    this.$DNS_IP,
                    this.path,
                    this.$session.getAll().data.shopId
                  )
                  await this.clearData()
                } else {
                  this.dataReady = true
                  this.$swal({
                    type: 'error',
                    title: 'แก้ไขข้อมูลไม่สำเร็จ',
                    text: response.data.message
                  })
                }
              })
              // eslint-disable-next-line handle-callback-err
              .catch(error => {
                console.log('error function updateDataGlobal : ', error)
                this.dataReady = true
              })
          })
          .catch(error => {
            console.log('error function updateData : ', error)
            this.dataReady = true
          })
      }
    },
    async addData () {
      this.validate('ADD')
      setTimeout(() => this.addDataSubmit(), 500)
    },
    async addDataSubmit () {
      if (this.validAdd !== false) {
        this.dataReady = false
        this.$swal({
          title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async result => {
            if (this.filesImageAdd && this.formAdd.urlImage === '') {
              const _this = this
              let params = new FormData()
              params.append('file', this.filesImageAdd)
              await axios
                .post(this.$DNS_IP + `/file/upload/settingPos`, params)
                .then(function (response) {
                  _this.formAdd.urlImage = response.data
                  console.log('url Pic', response.data)
                })
            } else {
              this.formAdd.urlImage = ''
            }
            console.log('forAdd', this.formAdd)
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.$DNS_IP + this.path + "add",
                this.formAdd
              )
              .then(async response => {
                console.log('addDataGlobal DNS_IP + PATH + "add"', response)
                if (response.data.status) {
                // Close Dialog
                  this.dialogAdd = false

                  // Load Data
                  await this.getDataGlobal(
                    this.$DNS_IP,
                    this.path,
                    this.$session.getAll().data.shopId
                  )
                  await this.clearData()
                } else {
                  this.dataReady = true
                  this.$swal({
                    type: 'error',
                    title: 'เพิ่มข้อมูลไม่สำเร็จ',
                    text: response.data.message
                  })
                }
              })
              // eslint-disable-next-line handle-callback-err
              .catch(error => {
                console.log('error function addDataGlobal : ', error)
                this.dataReady = true
              })
          })
          .catch(error => {
            console.log('error function addData : ', error)
            this.dataReady = true
          })
      }
    },
    async clearData () {
      for (var key in this.formAdd) {
        if (this.formAdd[key]) {
          if (key === 'shopId') {
            this.formAdd[key] = this.$session.getAll().data.shopId
          } else if (key === 'CREATE_USER') {
            this.formAdd[key] = this.$session.getAll().data.userName
          } else if (key === 'LAST_USER') {
            this.formAdd[key] = this.$session.getAll().data.userName
          } else {
            this.formAdd[key] = ''
          }
        }
      }
      for (var keyUpdate in this.formUpdate) {
        if (this.formUpdate[keyUpdate]) {
          if (keyUpdate === 'shopId') {
            this.formUpdate[keyUpdate] = this.$session.getAll().data.shopId
          } else if (keyUpdate === 'LAST_USER') {
            this.formUpdate[keyUpdate] = this.$session.getAll().data.userName
          } else {
            this.formUpdate[keyUpdate] = ''
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BeFood/setting_pos.vue